import { Box } from '@chakra-ui/react'
import { ToastContainer, Zoom } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ClientProvider } from './core/client/ClientProvider'
import { FeaturesProvider } from './core/features/FeaturesProvider'
import { CLIENT_ID } from './core/client/buildConfig'
import { SidebarProvider } from './context/SidebarContext'

// App wraps children with ClientProvider (theme, ChakraProvider) and
// FeaturesProvider (runtime feature flags from the backend).
export const App = ({ children }: { children: React.ReactNode }) => (
  <ClientProvider clientId={CLIENT_ID}>
    <FeaturesProvider>
      <SidebarProvider>
        <Box h='100dvh'>
          {children}
          <ToastContainer
            position='top-right'
            autoClose={10000}
            hideProgressBar={true}
            transition={Zoom}
            pauseOnHover
          />
        </Box>
      </SidebarProvider>
    </FeaturesProvider>
  </ClientProvider>
)

export default App
